import React, { useContext } from 'react';

// Context
import { boardTemplatePickerContext } from './context/boardTemplatePickerContext';

// Components
import { Content, Header, Sheet } from '../../mobile/structural/sheet';
import BoardTemplatePickerFooter from './pickerFooter/BoardTemplatePickerFooter';
import CustomTemplateLoader from './loader/CustomTemplateLoader';
import { CSSTransitionGroup } from '../../../node_module_clones/react-transition-group';
import BoardTemplatePickerHeader from './pickerHeader/BoardTemplatePickerHeader';
import BoardTemplatePickerCloseButton from './pickerHeader/BoardTemplatePickerCloseButton';
import BoardTemplatePickerBody from './pickerBody/BoardTemplatePickerBody';

// Constants
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { NavigationLevel } from './templateTypes';
import { UseSheetReturnType } from '../../mobile/structural/sheet/hooks/useSheet';

type Props = {
    currentBoard: ImMNElement;
    sheetProps: UseSheetReturnType;
    shouldAutoSelectTemplate: boolean;
};

const MobileBoardTemplatePickerSheetContent = ({ currentBoard, sheetProps, shouldAutoSelectTemplate }: Props) => {
    const { navigation, setNavigation, navigationTransition, selectTemplate } = useContext(boardTemplatePickerContext);

    return (
        <Sheet>
            <Header>
                <div className="picker-header">
                    <CSSTransitionGroup
                        transitionName={navigationTransition}
                        transitionEnterTimeout={400}
                        transitionLeaveTimeout={400}
                    >
                        <BoardTemplatePickerHeader
                            key={navigation.level === NavigationLevel.DEFAULT ? 'default' : 'back'}
                            navigation={navigation}
                            setNavigation={setNavigation}
                        />
                    </CSSTransitionGroup>

                    <BoardTemplatePickerCloseButton
                        selectTemplate={selectTemplate}
                        dismissTemplatePicker={sheetProps.dispatchCloseSheet}
                    />
                </div>
            </Header>
            <Content>
                <CustomTemplateLoader />

                <div className="picker-body-container">
                    <CSSTransitionGroup
                        transitionName={navigationTransition}
                        transitionEnterTimeout={400}
                        transitionLeaveTimeout={400}
                    >
                        <BoardTemplatePickerBody
                            key={navigation.level}
                            navigation={navigation}
                            shouldAutoSelectTemplate={shouldAutoSelectTemplate}
                        />
                    </CSSTransitionGroup>
                </div>

                <BoardTemplatePickerFooter
                    currentBoard={currentBoard}
                    dismissTemplatePicker={sheetProps.dispatchCloseSheet}
                />
            </Content>
        </Sheet>
    );
};

export default MobileBoardTemplatePickerSheetContent;
